export class Sprite_MapInvHeader extends KDCore.Sprite {
  constructor() {
    super();
    this._create();
  }

  enableAllButtons() {
    for (let i = 0; i < this.categoryBtns.length; i++) {
      const btn = this.categoryBtns[i];
      if(btn) btn.enable();
    }
  }

  getHoveredIndex() {
    for (let i = 0; i < this.categoryBtns.length; i++) {
      const btn = this.categoryBtns[i];
      if (btn && btn.isMouseInButton()) {
        return i;
      }
    }
    return null;
  }

  isMouseIn() {
    const pos = TouchInput;
    const rx = KDCore.SDK.canvasToLocalX(this._background, pos.x);
    const ry = KDCore.SDK.canvasToLocalY(this._background, pos.y);

    return rx >= 0 && ry >= 0 && rx <= this._background.width && ry <= this._background.height;
  }

  _create() {
    this._loadSettings();
    this._createBackground();
    this._drawIcon();
    this._createContent();
    this._createCloseButton();
  }

  _loadSettings() {
    this.settings = this._settingsJSON();
  }

  _settingsJSON() {
    return YsServices.equipmentService.getUIMapInventorySettings();
  }

  _createBackground() {
    this._background = YsServices.equipmentService.FromImgI(this.settings.headerBackImg);
    this.add(this._background);
  }

  _drawIcon() {
    if (!this.settings.icon) return;

    const icon = YsServices.equipmentService.FromImgI(this.settings.icon);
    icon.move(this.settings.iconMarginX, this.settings.iconMarginY);
    this.add(icon);
  }

  _createContent() {
    const availableCatList = this.settings.availableCategories;
    let addedCount = 0;

    this.categoryBtns = [];
    this._content = new Sprite();

    // this is must be above items! here...
    const img0 = ImageManager.loadInv(this.settings.categoryButtonImg);
    const img1 = ImageManager.loadInv(this.settings.categoryButtonHoverImg);
    const img3 = ImageManager.loadInv(this.settings.categoryButtonSelectedImg);

    if (availableCatList.items) {
      this._createItemsCategory(img0, img1, img3);
      addedCount++;
    } else {
      this.category1 = null;
      this.categoryBtns.push(null);
    }

    if (availableCatList.weapons) {
      this._createWeaponCategory(addedCount, img0, img1, img3);
      addedCount++;
    } else {
      this.categoryBtns.push(null);
    }

    if (availableCatList.armors) {
      this._createArmorCategory(addedCount, img0, img1, img3);
      addedCount++;
    } else {
      this.categoryBtns.push(null);
    }

    if (availableCatList.keyItems) {
      this._createKeyItemsCategory(addedCount, img0, img1, img3)
    } else {
      this.categoryBtns.push(null);
    }

    this._content.move(this.settings.categoryButtonsMarginX, this.settings.categoryButtonsMarginY);
    this._createCategoryIcons();
    this.add(this._content);
  }

  _createItemsCategory(img0, img1, img3) {
    this.category1 = new KDCore.Button();
    this.category1.setButtonImages(img0, img1, img0, img3);

    this.category1.addClickHandler(function() {
      SoundManager.playCursor();
      YsServices.equipmentService.invShowCategoryItems();
    });

    this._content.addChild(this.category1);
    this.categoryBtns.push(this.category1);
  }

  _createWeaponCategory(addedCount, img0, img1, img3) {
    this.category2 = new KDCore.Button();
    this.category2.setButtonImages(img0, img1, img0, img3);

    if (addedCount !== 0) {
      this.category2.move(this.settings.categoryButtonMarginBetween * addedCount, 0);
    } else {
      this.category2.move(0, 0); // line
    }

    this.category2.addClickHandler(function() {
      SoundManager.playCursor();
      YsServices.equipmentService.invShowCategoryWeapons();
    });

    this._content.addChild(this.category2);
    this.categoryBtns.push(this.category2);
  }

  _createArmorCategory(addedCount, img0, img1, img3) {
    this.category3 = new KDCore.Button();
    this.category3.setButtonImages(img0, img1, img0, img3);

    if (addedCount !== 0) {
      this.category3.move(this.settings.categoryButtonMarginBetween * addedCount, 0);
    } else {
      this.category3.move(0, 0); // line
    }

    this.category3.addClickHandler(function() {
      SoundManager.playCursor();
      YsServices.equipmentService.invShowCategoryArmors();
    });

    this._content.addChild(this.category3);
    this.categoryBtns.push(this.category3);
  }

  _createKeyItemsCategory(addedCount, img0, img1, img3) {
    this.category4 = new KDCore.Button();
    this.category4.setButtonImages(img0, img1, img0, img3);
    if (addedCount !== 0) {
      this.category4.move(this.settings.categoryButtonMarginBetween * addedCount, 0);
    } else {
      this.category4.move(0, 0); // line
    }
    this.category4.addClickHandler(function() {
      SoundManager.playCursor();
      YsServices.equipmentService.invShowCategoryKeyItems();
    });
    this._content.addChild(this.category4);
    this.categoryBtns.push(this.category4);
  }

  _createCategoryIcons() {
    let i, icon, j, ref, ref1, results;
    results = [];
    for (i = j = 0, ref = this.categoryBtns.length; (0 <= ref ? j < ref : j > ref); i = 0 <= ref ? ++j : --j) {
      icon = YsServices.equipmentService.FromImgI(this.settings.categoriesIcons[i]);
      results.push((ref1 = this.categoryBtns[i]) != null ? ref1.addChild(icon) : void 0);
    }
    return results;
  }

  _createCloseButton() {
    if (!this.settings.isCloseButtonVisible) return;

    this.closeBtn = new KDCore.Button();
    const img0 = ImageManager.loadInv(this.settings.closeButtonImg);
    const img1 = ImageManager.loadInv(this.settings.closeButtonHoverImg);

    this.closeBtn.setButtonImages(img0, img1, img0, img0);
    this.closeBtn.move(this.settings.closeButtonMarginX, this.settings.closeButtonMarginY);

    this.closeBtn.addClickHandler(function() {
      return YsServices.equipmentService.closeInventoryByClick();
    });

    this.add(this.closeBtn);
  }
}
